import { styled } from '@mui/material/styles';
import { Controller, Control } from 'react-hook-form';
import { Input, InputProps } from './Input';

const CustomFormInput = styled(Input)``;

export interface FormInputProps extends Omit<InputProps, 'onChange' | 'onBlur' | 'value'> {
  control?: Control<any>;
  name: string;
  rules?: object;
}

export const FormInput: React.FC<FormInputProps> = ({ control, name, rules, ...props }) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value: fieldValue, onChange: fieldOnchange, onBlur: fieldOnBlur } }) => (
        <CustomFormInput {...props} value={fieldValue || ''} onChange={fieldOnchange} onBlur={fieldOnBlur} />
      )}
    />
  );
};
